var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePdfRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_10",
    "data-name": "Differenzmenge 10",
    d: "M17,19H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H17a2,2,0,0,1,2,2V17A2,2,0,0,1,17,19ZM12.988,6.916V12.5H14.2V10.212h2.12V9.14H14.2V8h2.489V6.916Zm-5.376,0V12.5h2.1a2.781,2.781,0,0,0,1.008-.176A2.038,2.038,0,0,0,11.5,11.8a2.4,2.4,0,0,0,.5-.872,3.859,3.859,0,0,0,.175-1.219A3.862,3.862,0,0,0,12,8.488a2.4,2.4,0,0,0-.5-.872,2.038,2.038,0,0,0-.776-.524,2.8,2.8,0,0,0-1.008-.176Zm-5.048,0V12.5H3.78V10.484H5.2a1.794,1.794,0,0,0,.7-.132,1.567,1.567,0,0,0,.533-.364,1.611,1.611,0,0,0,.339-.56,2.247,2.247,0,0,0,0-1.453,1.593,1.593,0,0,0-.339-.563,1.567,1.567,0,0,0-.533-.365,1.794,1.794,0,0,0-.7-.132Zm7.152,4.5H8.828V8h.888a1.179,1.179,0,0,1,.856.3,1.322,1.322,0,0,1,.311.976v.864a1.321,1.321,0,0,1-.311.976A1.179,1.179,0,0,1,9.716,11.42ZM5.06,9.428H3.78V7.972H5.06a.625.625,0,0,1,.428.139.53.53,0,0,1,.156.412v.352a.53.53,0,0,1-.156.412A.621.621,0,0,1,5.06,9.428Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdfRegular);
export default __webpack_public_path__ + "static/media/file-pdf-regular.03f367f8a20fd412656b3ce2d4521f01.svg";
export { ForwardRef as ReactComponent };